import { render, staticRenderFns } from "./PlacesDetail.vue?vue&type=template&id=50b1dd24&scoped=true&"
import script from "./PlacesDetail.vue?vue&type=script&lang=js&"
export * from "./PlacesDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlacesDetail.vue?vue&type=style&index=0&id=50b1dd24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b1dd24",
  null
  
)

export default component.exports